export default (function (_ref) {
  var valid = _ref.valid,
      message = _ref.message;
  return {
    valid: valid,
    message: message
  };
});